/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Favourite_RemoveInputs */

const en_favourite_remove = /** @type {(inputs: Favourite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from favourites`)
};

const de_favourite_remove = /** @type {(inputs: Favourite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Favoriten entfernen`)
};

/**
* | output |
* | --- |
* | "Remove from favourites" |
*
* @param {Favourite_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const favourite_remove = /** @type {((inputs?: Favourite_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favourite_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_favourite_remove(inputs)
	return en_favourite_remove(inputs)
});